<template>
    <div>
        <b-row>
            <b-col md="12" class="text-left text-md-right">
                <b-button variant="primary new-button"
                    @click="addStore">
                    + New Store
                </b-button>
            </b-col>
        </b-row>
        <div class="data-container row">
            <b-table show-empty
                :empty-text="(loading) ? 'Loading data' : 'No Data Available'"
                :items="list"
                :fields="fields"
                responsive>
                <template slot="store_id" slot-scope="data">
                    {{ data.item.isr_code }}
                </template>
                <template slot="contact_details" slot-scope="data">
                    {{ data.item.phone }}
                </template>
                <template slot="action" slot-scope="data">
                    <b-button
                        variant="ghost btn-table-edit"
                        @click="editStore(data.item.uuid)">
                    </b-button>
                    <b-button
                        variant="ghost btn-table-delete"
                        @click="deleteStore({
                            uuid: data.item.uuid,
                            store_name: data.item.store_name
                        })">
                    </b-button>
                </template>
            </b-table>
        </div>
        <b-row>
            <b-col>
                <div class="mt-1">
                    <span class="pagination-indicator">Showing {{ pagination.currentFirstItem }} to {{ pagination.currentLastItem }} of {{ pagination.maxPage }} pages</span>
                </div>
            </b-col>
            <b-col>
                <b-pagination
                    hide-goto-end-buttons
                    align="right"
                    size="md"
                    class="custom-pagination"
                    :total-rows="(pagination.totalPerPage > 0) ? pagination.maxPage * pagination.totalPerPage : 1"
                    :limit="(pagination.totalPerPage > 0) ? 5 : 1"
                    :per-page="pagination.totalPerPage"
                    @change="paginate">
                </b-pagination>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapState } from "vuex";

import Datepicker from "vue-bulma-datepicker";
const list = [
    {
        uuid: "7r19878197219709172",
        store_name: "Manila Store",
        store_id: "00000001",
        store_type: "Sarisari store",
        contact_details: "091723456789",
        tier: "Platinum"
    }
];
const fields = [
    { key: "store_name", sortable: true },
    { key: "store_id", label: "Store ID", sortable: true },
    { key: "store_type", sortable: true },
    { key: "contact_details", sortable: true },
    { key: "tier", sortable: true },
    { key: "action" }
];
export default {
    name: "CustomersStores",
    computed: {
        ...mapState("customers", ["uuid"]),
        ...mapState("reportsStores", ["loading", "store_modal", "list", "pagination", "param", "membership_id"]),
        daterangeConfig: {
            get: function() {
                let _this = this;
                return {
                    altInput: true,
                    altFormat: "M j, Y",
                    dateFormat: "Y-m-d",
                    static: true,
                    mode: "range",
                    defaultDate: ["today", "today"],
                    onChange: function(selectedDates) {
                        // console.log(selectedDates);
                        // _this.selectedDate(selectedDates);
                        // _this.range = selectedDates;
                    }
                };
            }
        }
    },
    data() {
        return {
            range: null,
            storeFilter: "all",
            storeFilters: [
                {
                    value: "all",
                    text: "All Transactions"
                }
            ],
            fields: fields
        };
    },
    components: {
        Datepicker
    },
    methods: {
        addStore: function() {
            this.$store.commit("reportsStores/setModal", {
                type: "new",
                status: true
            });
        },

        editStore: function(uuid) {
            this.$store.commit("reportsStores/setModal", {
                type: "edit",
                status: true,
                uuid: uuid
            });
        },

        deleteStore: function(data) {
            this.$store.commit("reportsStores/setModal", {
                type: "delete",
                status: true,
                uuid: data.uuid,
                store_name: data.store_name
            });
        },

        paginate: async function(page) {
            this.$store.commit("reportsStores/loading", true);
            await this.$store.commit("reportsStores/setPage", page);
            await this.$store
                .dispatch("reportsStores/getList", {
                    membership_id: this.membership_id,
                    page: page
                })
                .then(() => {
                    this.$store.commit("reportsStores/loading", false);
                });
        }
    }
}
</script>
